import React, {Component} from 'react';

class Footer extends Component {
  render() {
      const d = new Date();
    return (
      <footer className="app-footer">
        <span>MGrid {VERSION} ✈ &copy; {d.getFullYear()} Methodia LTD.</span>
        <span className="ml-auto"></span>
      </footer>
    )
  }
}

export default Footer;
